<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> مدیریت مرخصی ها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-2 px-2">

    <div class="border border-2 p-2">

        <div class="row gx-0 gy-0">

            <div class="col-10">

                <input class="w-100 form-control" placeholder="بر اساس شماره، نام خط و نام و نام خانوادگی جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            </div>

            <div class="col-2 px-2">

                <button class="btn btn-success" (click)="exportExcel()"> خروجی اکسل </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 169px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead class="">

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center"> عملیات </th>
                        
                        <th class="text-center"> شماره </th>

                        <th class="text-center"> نام خط </th>

                        <th class="text-center"> نام راننده </th>
                        
                        <th class="text-center"> وضعیت </th>

                        <th class="text-center"> تاریخ ثبت </th>

                        <th class="text-center"> تاریخ شروع </th>
                        
                        <th class="text-center"> مرخصی قبلی </th>


                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Vacations;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="">

                            <i class="fa fa-eye fa-lg pointer" aria-hidden="true" (click)="view_Details(item,i)"></i>

                        </td>

                        <td> {{ item.iTaxi_Vacation | faNum }} </td>

                        <td> {{ item.strTaxiLine | faNum }} </td>

                        <td> {{ item.strFullName | faNum }} </td>

                        <td> {{ item.strStatus | faNum }} </td>

                        <td dir="ltr"> {{ item.strDateTime | faNum }} </td>

                        <td> {{ item.strSDate | faNum }} </td>

                        <td> {{ item.tiYearVacations | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="vacation_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> مشاهده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <ng-container *ngIf="mdl_Request.get('strFullName')?.value">

                <div class="modal-body">
    
                    <!-- مشخصات راننده -->
    
                    <div [formGroup]="mdl_Request" class="row gx-2 gy-2">
    
                        <!-- نام خانوادگی -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> نام و نام خانوادگی </label>
    
                            <input class="form-control p-2 text-center" formControlName="strFullName">
    
                        </div>
    
                        <!-- پلاک -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> پلاک </label>
    
                            <input class="form-control p-2 text-center" formControlName="strVehicleNo">
    
                        </div>
    
                        <!-- موبایل -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> موبایل </label>
    
                            <input class="form-control p-2 text-center" formControlName="strMobile">
    
                        </div>
    
                        <!-- خط -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> خط </label>
    
                            <input class="form-control p-2 text-center" formControlName="strTaxiLine">
    
                        </div>
    
                        <!-- تعداد مرخصی امسال -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> تعداد مرخصی امسال </label>
    
                            <input class="form-control p-2 text-center" formControlName="tiYearVacations">
    
                        </div>
    
                    </div>
    
                    <!-- مشخصات مرخصی -->
    
                    <div [formGroup]="mdl_Request" class="row gx-2 gy-2 mt-3">
    
                        <!-- تاریخ شروع -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> تاریخ شروع </label>
    
                            <input class="form-control p-2 text-center" formControlName="strSDate">
    
                        </div>
    
                        <!-- تاریخ پایان -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> تاریخ پایان </label>
    
                            <input class="form-control p-2 text-center" formControlName="strEDate">
    
                        </div>
    
                        <!-- راننده جایگزین -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> راننده جایگزین </label>
    
                            <input class="form-control p-2 text-center" formControlName="strSubstituteDriver">
    
                        </div>
    
                        <!-- شهر -->
    
                        <div class="position-relative col-12 col-md-4 p-2">
    
                            <label class="mb-2 text-muted"> شهر </label>
    
                            <input class="form-control p-2 text-center" formControlName="strDCityName">
    
                        </div>
    
                        <!-- توضیحات -->
    
                        <div class="position-relative col-12 p-2">
    
                            <label class="mb-2 text-muted"> توضیحات </label>
    
                            <textarea style="height: 80px;resize: none;" class="form-control" formControlName="strComment"></textarea>
    
                        </div>
    
                    </div>

                    <!-- عملیات -->

                    <ng-container *ngIf="mdl_Request.get('tiStatus')?.value as status; ">

                        <div *ngIf="status == 0 || status == 2" class="row gx-2 gy-2">
    
                            <div class="col-12 p-2">
    
                                <button class="btn btn-success" (click)="Approve_Reject(mdl_Request.value,1)"> 
    
                                    &nbsp; تایید &nbsp;
                                    
                                </button>    
    
                                <button class="btn btn-danger mx-2" (click)="Approve_Reject(mdl_Request.value,2)"> 
    
                                    &nbsp; رد &nbsp;
                                    
                                </button>    
        
                            </div>
    
                        </div>

                    </ng-container>
    
                </div>

            </ng-container>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>